import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=60963ef1&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=ts&"
export * from "./OrderOverview.vue?vue&type=script&lang=ts&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=60963ef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60963ef1",
  null
  
)

/* custom blocks */
import block0 from "./OrderOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports